module.exports = __webpack_public_path__ + "img/144.325fb338.jpg";